// ✅ DoctorLogin.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../loginServices/loginStyle.css';
import AuthService from '../Security/AuthService';
import DoctorInfoService from '../doctorInfo/doctorInfoService';
import { checkSessionExpiration, resetInactivityTimer } from '../loginServices/sessionManager';

const authService = new AuthService();
const doctorService = new DoctorInfoService();

const DoctorLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageStyle, setMessageStyle] = useState('');
  const [spinnerVisible, setSpinnerVisible] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    checkSessionExpiration();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSpinnerVisible(true);
    setMessage('');

    try {
      const loginResult = await authService.login({ username, password });
      const roleData = await authService.getUserRole(username);
      const role = roleData.role.replace('ROLE_', '');

      const doctorDetails = await doctorService.getDoctorByUsername(username);

      localStorage.setItem('jwt', loginResult.token);
      localStorage.setItem('role', role);
      localStorage.setItem('username', username);
      localStorage.setItem('doctorId', doctorDetails.doctorId);

      window.dispatchEvent(new Event('userUpdated'));

      setMessage(`Login successful as ${role}`);
      setMessageStyle('green');
      resetInactivityTimer();

      setTimeout(() => navigate('/dashboard/doctor'), 1500);
    } catch (error) {
      setMessage('Login failed. Please check your credentials.');
      setMessageStyle('red');
    } finally {
      setSpinnerVisible(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-title-block doctor-login-title">
          <h1>Doctor Login</h1>
          <p>Staff and providers should sign in here.</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Doctor Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="input-field"
            autoComplete="username"
          />

          <input
            type="password"
            placeholder="Doctor Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input-field"
            autoComplete="current-password"
          />

          <button type="submit" className="login-button">
            Doctor Login
          </button>

          {spinnerVisible && <div className="spinner"></div>}
        </form>

        <div className="login-switch-note">
          <span>Are you a patient?</span>
          <button
            type="button"
            className="link-button"
            onClick={() => navigate('/login/patient')}
          >
            Go to Patient Login
          </button>
        </div>

        {message && (
          <div className="message" style={{ color: messageStyle }}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default DoctorLogin;